import CEUtils from '@cekit/ce-utils';

let vm = undefined;

export const registerVm = function (ivm) {
    vm = ivm;
    return true;
};

// TODO WQ 这个地方能不能用还不清楚，等待后续测试
export const logJson = function ({ logObj = {}, logFlag = {} }) {
    // 已有埋点数据保持现状
    let { appCode = null, title, parent } = vm.$route.meta; // 当前路由
    // 扁平化路由菜单，方便匹配
    let menus = CEUtils.toTreeArray(vm.$store.state.routes&&vm.$store.state.routes.routes.children, { children: 'children', clear: false });
    // 当前应用无appcode,则找其父级
    if (!appCode) {
        let _arr = menus.filter(v => v.path.includes(parent));
        if (_arr.length > 0) {
            appCode = _arr[0].appCode;
        }
    }
    const { isSuper, name } = vm.$store.state.user.userdata; // 登录类型 0 超级管理员，1 属于普通管理员
    console.log('thy', logObj)
    // 没写入的数据 默认按照格式追加
    if (!logObj.optlog?.dataJSON || logObj.optlog?.dataJSON?.length == 0) {
        // 有栏目才ping数据
        if (logFlag.columnName) {
            if (logObj.optlog?.dataJSON) {
                logObj.optlog.dataJSON = [{id: -1,title: logFlag.columnName}]
            }
        }
    }
    // 拼装数据
    const optlog = {
        ...logObj.optlog,
        ...logFlag,
        appId: appCode,
        // loginUser: isSuper != 0 ? name : ''
    };
    console.log(optlog, '日志信息');
    return encodeURIComponent(JSON.stringify(optlog));
};
